import { render, staticRenderFns } from "./voucherGoodsItem.vue?vue&type=template&id=224ec98a&scoped=true"
import script from "./voucherGoodsItem.vue?vue&type=script&lang=js"
export * from "./voucherGoodsItem.vue?vue&type=script&lang=js"
import style0 from "./voucherGoodsItem.vue?vue&type=style&index=0&id=224ec98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ec98a",
  null
  
)

export default component.exports